import { css } from '@emotion/css'

export const confirmContent = css`
  white-space: pre-wrap;
  font-family: 'Noto Sans JP';
  margin: 0;
`
